define(function(require) {
    // GEO07E20_BASSINS layer definition config
    return {
        LAYER_ID : "GEO07E20_BASSINS",
        LAYER_TYPE : "POLYGON",
        USE_TYPED_ARRAY : true,
        LOADING_MODE : "INITIAL",
        TOKEN_REQUIRED: true,
        INDEX : 16,
        DATATABLE_ID : "t_GEO07E20_BASSINS",
        QUERY_FIELDS : ["CD_BASSIN", "NOM_BASSIN", "CD_COULR"],
        FIELDS : [
            {ID : "CD_BASSIN", NAME : "Code", DATA_TYPE: "STRING", VALUE : "{{CD_BASSIN}}"},
            {ID : "NOM_BASSIN", NAME : "Nom", DATA_TYPE: "STRING", VALUE : "{{NOM_BASSIN}}"},
            {ID: "CD_COULR", NAME: "CD_COULR", DATA_TYPE: "STRING", VALUE: "{{CD_COULR}}"},
        ],
        STYLES: [
            {
                ID: "Bassin_1",
                VALUE: 1,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(253,0,0,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(253,0,0,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_2",
                VALUE: 2,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(178,110,50,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(178,110,50,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_3",
                VALUE: 3,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(16,159,207,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(16,159,207,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_4",
                VALUE: 4,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(97,167,22,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(97,167,22,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_5",
                VALUE: 5,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(236,124,87,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(236,124,87,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_6",
                VALUE: 6,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(37,191,194,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(37,191,194,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }, {
                ID: "Bassin_7",
                VALUE: 7,
                SYMBOLIZERS: [
                    {
                        SYMBOLIZER_TYPE: "PolygonSymbolizer",
                        FILL_STYLE: "NONE",
                        STROKE_COLOR: "rgba(163,88,225,1)",
                        STROKE_STYLE: "LINE",
                        STROKE_WIDTH: 3
                    }
                ],
                STYLE_LABEL_PROPERTIES: {
                    BOLD: true,
                    COLOR: "rgba(163,88,225,1)",
                    FONT_NAME: "Arimo-Regular",
                    FONT_FILE_SOURCE: "fonts/externals/Arimo-Regular",
                    HALO_COLOR: "rgba(255,255,255,1)",
                    HAS_HALO_COLOR: true,
                    SIZE: 9,
                    VISIBLE: false
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Bassin",
            FEATURE_ID_DATACOLUMN : "CD_BASSIN",
            FEATURE_NAME_DATACOLUMN : "CD_BASSIN",
            DATATIP_DATACOLUMNS : ["CD_BASSIN", "NOM_BASSIN"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["CD_BASSIN", "NOM_BASSIN"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["CD_BASSIN", "NOM_BASSIN"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            //SEARCHABLE_DATACOLUMNS : ["CD_BASSIN", "NOM_BASSIN"],
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            STYLE_DATACOLUMN: "CD_COULR",
            LABEL_DATACOLUMN : "NOM_BASSIN",
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : false,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 5
            },
            VISIBLE : false,
            BLEND_MODE : "NORMAL",
        }
    };
});
